import { render, staticRenderFns } from "./FilmPlaylist.vue?vue&type=template&id=24befd43&scoped=true"
import script from "./FilmPlaylist.vue?vue&type=script&lang=js"
export * from "./FilmPlaylist.vue?vue&type=script&lang=js"
import style0 from "./FilmPlaylist.vue?vue&type=style&index=0&id=24befd43&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24befd43",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VToolbar } from 'vuetify/lib/components/VToolbar';
import { VToolbarTitle } from 'vuetify/lib/components/VToolbar';
installComponents(component, {VCard,VToolbar,VToolbarTitle})
